import { ICustomer } from '../../Customer/interfaces/ICustomer'
import { IHICustomer } from '../interfaces/IHealthInsurance'


// TODO replace name with last name
export const transformCustomerToHICustomer = (
  customer: ICustomer,
): IHICustomer => ({
  firstName: customer.firstName,
  lastName: customer.lastName || null,
  customerId: customer.id,
})
